/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import NotSupportedPageView from "app/preview/react-component/not-supported/presentation/NotSupportedPageView";
import { observer } from "mobx-react";
import React from "react";

 @observer
export default class NotSupportedPageContainer extends React.PureComponent {
     render() {
         return (
             <NotSupportedPageView
                 { ... this.props }
             />
         );
     }
 }
